export default config =
    tomato: 25,
    short: 5,
    long: 15,
    interval: 4
